import { render, staticRenderFns } from "./in.vue?vue&type=template&id=a0dcbca8&scoped=true&"
import script from "./in.vue?vue&type=script&lang=js&"
export * from "./in.vue?vue&type=script&lang=js&"
import style0 from "./in.vue?vue&type=style&index=0&id=a0dcbca8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dcbca8",
  null
  
)

export default component.exports